import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import msal, { loginRequest } from 'lib/msal';
import * as microsoftTeams from "@microsoft/teams-js";
import { Spinner } from 'UI';

var GenerateToken = /*#__PURE__*/function (_Component) {
  _inherits(GenerateToken, _Component);

  var _super = _createSuper(GenerateToken);

  function GenerateToken() {
    var _this;

    _classCallCheck(this, GenerateToken);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (window.location.hash.indexOf('code') > -1) {
        msal.handleRedirectPromise().then(function (response) {
          if (response != null) {
            microsoftTeams.authentication.notifySuccess(response);
          } else {
            microsoftTeams.authentication.notifyFailure('');
          }
        })["catch"](function (reason) {
          microsoftTeams.authentication.notifyFailure(reason);
        });
        return true;
      }

      var request = JSON.parse(localStorage.getItem('haldor-teams-auth-request'));
      request.redirectUri = window.location.origin + '/GenerateToken';
      msal.acquireTokenRedirect(request);
    });

    return _this;
  }

  _createClass(GenerateToken, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }));
    }
  }]);

  return GenerateToken;
}(Component);

export default GenerateToken;